<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    filled
    :items="dados"
    item-text="lmecodigoarmazem"
    :outlined="outlined"
    :append-icon="icon"
    v-model="id"
    @click:append="action"
    @keydown.enter="$_selecionaPrimeiro"
    background-color="white"
    :class="{['mb-5']: true, ['upper-text']: upper}"
    hide-details
    ref="focusinput">
    <template v-slot:item="dados">
      <!-- Voltar o return object? -->
      <template>
        <v-list-item-content class="divisao">
          <v-list-item-subtitle>
              <div class="spaceout">
                <b>
                  {{dados.item.lmecodigoarmazem}}
                </b>
                <b>
                  -
                </b>
                <b v-if="dados.item.lmeidlocalmovimentacaoestoque">
                  {{dados.item.lmeidlocalmovimentacaoestoque}}
                </b>
                <b v-else>
                    - - -
                </b>
              </div><br/>
                {{dados.item.lmedescricao}}
                <br/>
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>

import moment from 'moment-timezone';

export default {
  name: 'CoreBtnAutoComplete',

  // ESTA CONFIGURADO PARA LOCALARMAZENAMENTO | | | | | | | | | | | | | | | | | | | | | | |

  props: {
    // support v-model on the custom component (prop `value` + emit `input`)
    value: {
      required: false,
      default: null,
    },
    icon: {
      type: String,
      default: 'mdi-dots-horizontal-circle-outline',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    redirect: {
      type: Object,
      default: null,
    },
    modal: {
      type: Boolean,
      default: null,
    },
    dados: {
      type: Array,
      default: (() => ([])),
    },
    itemLabel: {
      type: String,
      default: '',
    },
    temvazio: {
      type: Boolean,
      default: false,
    },
    paramappend: {
      default: null,
    },
    action: {
      type: Function,
      default: (() => {}),
    },
    expand: {
      type: Boolean,
      default: (() => {}),
    },
    upper: {
      type: Boolean,
      default: (() => {}),
    },
  },

  data() {
    return {
      txtInput: '',
      select: null,
      id: this.value,
    };
  },

  methods: {
    $_trataClique() {
      if (this.$props.redirect) {
        this.$router.replace({
          ...this.$route,
          name: this.$props.redirect.name,
        });
      } else {
        this.$refs.focusinput.focus();
      }
    },

    $_validaFrota() {
      this.$emit('frotaAlterada', this.txtInput);
    },

    $_returnValor() {
      this.$refs.focusinput.value = this.$refs.focusinput.valu.ablnrocontrole;
    },

    $_formataData(date, mascara) {
      return moment.tz(date, 'America/Sao_Paulo').local().format(mascara);
    },

    $_selecionaPrimeiro() {
      if (this.$refs.focusinput.$children[1].listIndex === -1) {
        this.$refs.focusinput.$children[1].listIndex = 0;
      }
    },
  },

  beforeMount() {
    this.select = this.$props.dados;
    if (this.$props.temvazio) {
      this.select.push({ [this.$props.itemLabel]: 'vazio' });
    }
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },

  watch: {
    id: {
      deep: true,
      immediate: true,
      handler() {
        // emit input so parent v-model is updated
        this.$emit('input', this.id);
        this.$emit('localSelecionado');
      },
    },
    value(newVal) {
      // sync external prop changes into internal id
      this.id = newVal;
    },
  },
};
</script>

/* CHANGELOG */
/*
  V2: Adicionado Action aos props, para alimentar a função de clique externamente.
*/

<style scoped>
  .spaceout {
    display: flex;
    justify-content: space-between;
  }

  .divisao {
    border-bottom: 1px solid #dddddd;
  }

  .upper-text >>> input {
    text-transform: uppercase !important;
  }

</style>
